import React from 'react';
import type { ApolloError } from 'apollo-client';
import type { MessageDescriptor } from 'react-intl-next';

import { ErrorDisplay } from '@confluence/error-boundary';

import { ClassificationLevelError } from '../ContentClassificationLevel/ClassificationLevelError';

import { sharedMessages } from './sharedMessages';

type ClassificationTagButtonErrorProps = {
	contentLevelError?: ApolloError;
	spaceLevelError?: ApolloError;
	primaryText?: MessageDescriptor;
	secondaryText?: MessageDescriptor;
};

export const ClassificationTagButtonError = ({
	contentLevelError,
	spaceLevelError,
	primaryText,
	secondaryText,
}: ClassificationTagButtonErrorProps) => {
	return (
		<>
			{contentLevelError ? <ErrorDisplay error={contentLevelError} /> : null}
			{spaceLevelError ? <ErrorDisplay error={spaceLevelError} /> : null}
			<ClassificationLevelError
				primaryText={primaryText || sharedMessages.fetchErrorTextPrimary}
				secondaryText={secondaryText || sharedMessages.fetchErrorTextSecondary}
				isTagDisplayError
			/>
		</>
	);
};
